import React from "react";
import "./FooterStyle.css";

import { FaReact } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { IoLogoVercel } from "react-icons/io5";
import { FcAbout } from "react-icons/fc";
const Footer = () => {
  return (
    <div>
      <div className="footer-container">
        <h2>
          致谢：
          <a href="https://react.dev/">
            <FaReact />
            React
          </a>
          <a href="https://github.com/atelier-anchor/smiley-sans">
            <FaGithub />
            Smiley
          </a>
          <a href="https://vercel.com/">
            <IoLogoVercel />
            vercel
          </a>
          <a href="https://github.com/Noah-wang">
            <FcAbout />
            关于我
          </a>
        </h2>
      </div>
    </div>
  );
};
export default Footer;
